export enum FirebaseModule {
  AUTH = "auth",
  STORAGE = "storage",
  FIRESTORE = "firestore",
  ANALYTICS = "analytics",
}

export const getFirebaseClient = async (
  firebaseConfig: any,
  modules: FirebaseModule[]
) => {
  const firebase: any = await import("firebase/app");

  const firebaseModules = await Promise.all([
    modules.indexOf(FirebaseModule.AUTH) != -1
      ? import("firebase/auth")
      : undefined,
    modules.indexOf(FirebaseModule.STORAGE) != -1
      ? import("firebase/storage")
      : undefined,
    modules.indexOf(FirebaseModule.FIRESTORE) != -1
      ? import("firebase/firestore")
      : undefined,
    modules.indexOf(FirebaseModule.ANALYTICS) != -1
      ? import("firebase/analytics")
      : undefined,
  ]);

  firebase.initializeApp(firebaseConfig);

  return {
    ...firebase,
    auth: firebaseModules[0],
    storage: firebaseModules[1],
    firestore: firebaseModules[2],
    analytics: firebaseModules[3],
  };
};

export const getStorage = (firebase: any) => {
  return {
    storage: firebase.storage.getStorage(),
    ...firebase.storage,
  };
};

export const getAuth = (firebase: any) => {
  return {
    auth: firebase.auth.getAuth(),
    ...firebase.auth,
  };
};

export const getFirestore = (firebase: any) => {
  return {
    firestore: firebase.firestore.getFirestore(),
    ...firebase.firestore,
  };
};

export const getAnalytics = (firebase: any) => {
  return {
    analytics: firebase.analytics.getAnalytics(),
    ...firebase.analytics,
  };
};
